import { render, staticRenderFns } from "./add-role.vue?vue&type=template&id=2aa676ba"
import script from "./add-role.vue?vue&type=script&lang=js"
export * from "./add-role.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports